/**
 * Meldet dem Abgleich, dass lokal etwas geschrieben wurde.
 *
 * Bis zum 20.09.2026 wurde nach einer Änderung nichts hochgeladen, bis der
 * Timer alle 30 Sekunden tickte. Ein Abhaken erreichte das andere Telefon
 * im Laden also erst nach bis zu 30 Sekunden, gemessen 29,6 bis 30,1. Das
 * Depot (repository.ts) kennt den Runner nicht und soll ihn nicht kennen,
 * deshalb ein Ereignis am Fenster, wie bei assistant-events.ts.
 */
const NAME = "ainkauf:outbox";

export function outboxGeaendert(): void {
  window.dispatchEvent(new Event(NAME));
}

export function aufOutbox(horcher: () => void): () => void {
  window.addEventListener(NAME, horcher);
  return () => {
    window.removeEventListener(NAME, horcher);
  };
}
